export default "__VITE_ASSET__Cf1cW$Wi__"